import React from 'react';

const Message: React.VFC = () => (
  <svg width="31" height="25" viewBox="0 0 31 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30.0834 3.74992C30.0834 2.14575 28.7709 0.833252 27.1667 0.833252H3.83335C2.22919 0.833252 0.916687 2.14575 0.916687 3.74992V21.2499C0.916687 22.8541 2.22919 24.1666 3.83335 24.1666H27.1667C28.7709 24.1666 30.0834 22.8541 30.0834 21.2499V3.74992ZM27.1667 3.74992L15.5 11.0416L3.83335 3.74992H27.1667ZM27.1667 21.2499H3.83335V6.66658L15.5 13.9583L27.1667 6.66658V21.2499Z" fill="#333333" />
  </svg>
);

export default Message;
